module.exports = __webpack_public_path__ + "img/htcm_00.383036ff.jpg";